import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/evcs_operators',
  component: Management,
  redirect: '/evcs_operators/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/evcs_operators/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.listEvcsOperators
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/evcs_operators/ListTable'),
          meta: {
            auth: Auth.listEvcsOperators,
            tabName: 'all'
          }
        }
      ]
    },
    // 新增
    {
      path: 'new',
      component: () => import('@/views/evcs_operators/New'),
      meta: {
        auth: Auth.createEvcsOperator
      }
    },
    // 编辑
    {
      path: ':id/edit',
      component: () => import('@/views/evcs_operators/Edit'),
      meta: {
        auth: Auth.updateEvcsOperator
      }
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/evcs_operators/DetailLayout'),
      meta: {
        auth: Auth.showEvcsOperator
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/evcs_operators/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showEvcsOperator
          }
        },
        {
          path: 'communicate_config',
          component: () => import('@/views/evcs_operators/details/CommunicateConfig'),
          meta: {
            tabName: 'communicate_config', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showEvcsOperator
          }
        },
        {
          path: 'open_api',
          component: () => import('@/views/evcs_operators/details/OpenApi'),
          meta: {
            tabName: 'open_api', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showEvcsOperator
          }
        },
        {
          path: 'debugger',
          component: () => import('@/views/evcs_operators/details/Debugger'),
          meta: {
            tabName: 'debugger', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showEvcsOperator
          }
        }
      ]
    }
  ]
}
